interface ProgressProps {
	value: number; // 0-100
	className?: string;
	label?: string;
}

export function Progress({ value, className = "", label }: ProgressProps) {
	return (
		<div className={`w-full ${className}`}>
			{label && (
				<div className="flex justify-between text-sm text-gray-600 mb-1">
					<span>{label}</span>
					<span>{Math.round(value)}%</span>
				</div>
			)}
			<div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
				<div
					className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
					style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
					role="progressbar"
					aria-valuenow={value}
					aria-valuemin={0}
					aria-valuemax={100}
				/>
			</div>
		</div>
	);
}
